import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_110: FaireProductEntity = {
  token: "starter_collection_110",
  type: "product",
  name: "Best Wine Key - Noir",
  brandName: "Craighill",
  imageUrl:
    '"https://cdn.faire.com/fastly/c740c0addae925de1a6daf50c751efe35dd4cf9489a489eeecc3f8ba5588a648.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=2247',
  priceDollars: 48,
  msrpDollars: 96,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
